<template>
  <div class="content-chart">
    <div v-for="(item,i) in chartConfig" v-bind:key="i" class="chart-box">
      <component v-bind:is="item.name" v-bind:option="item.option" v-bind:load="item.load" v-bind:clear="item.clear"></component>
    </div>
  </div>
</template>
<script>
import randerChart from './randerChart'
import barChart from './barChart'
import stackBarChart from './stackBarChart'
import scatterChart from './scatterChart'
import lineChart from './lineChart'
import pieChart from '@/components/chart/pieChart'
export default {
  data () {
    return {}
  },
  props: {
    chartConfig: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  components: {
    randerChart,
    barChart,
    stackBarChart,
    scatterChart,
    lineChart,
    pieChart
  },
  mounted () {
  }
}
</script>
<style lang="less" scoped>
.content-chart {
  flex: 1;
  display: flex;
  flex-flow: row;
  overflow: hidden;
  .chart-box {
    flex: 1;
  }
}
</style>
